export const HOME = { emergentLink: "home-emergent-link" };

export const SOCIAL_PROOF = {
  popup: "social-proof-popup",
  closeBtn: "social-proof-close-btn",
};

export const PURCHASE_STEPS = {
  container: "purchase-steps-reassurance",
  step: (n) => `purchase-steps-step-${n}`,
};

export const NAV = {
  logo: "nav-logo",
  home: "nav-home",
  create: "nav-create",
  dashboard: "nav-dashboard",
  admin: "nav-admin",
  login: "nav-login-btn",
  logout: "nav-logout-btn",
  languageSwitcher: "nav-language-switcher",
  themeToggle: "nav-theme-toggle",
  mobileMenuBtn: "nav-mobile-menu-btn",
  notificationsBell: "nav-notifications-bell",
};

export const AUTH = {
  loginEmail: "auth-login-email",
  loginPassword: "auth-login-password",
  loginSubmit: "auth-login-submit",
  registerName: "auth-register-name",
  registerEmail: "auth-register-email",
  registerPassword: "auth-register-password",
  registerSubmit: "auth-register-submit",
  googleBtn: "auth-google-btn",
  switchToRegister: "auth-switch-to-register",
  switchToLogin: "auth-switch-to-login",
  forgotPasswordLink: "auth-forgot-password-link",
  forgotPasswordEmail: "auth-forgot-password-email",
  forgotPasswordSubmit: "auth-forgot-password-submit",
  resetPasswordInput: "auth-reset-password-input",
  resetPasswordSubmit: "auth-reset-password-submit",
};

export const LANDING = {
  heroCta: "landing-hero-cta",
  heroSecondaryCta: "landing-hero-secondary-cta",
  pricingCard: (id) => `landing-pricing-card-${id}`,
  faqItem: (id) => `landing-faq-item-${id}`,
};

export const TRY_FREE = {
  container: "try-free-container",
  promptInput: "try-free-prompt-input",
  styleChip: (id) => `try-free-style-chip-${id}`,
  moodChip: (id) => `try-free-mood-chip-${id}`,
  generateBtn: "try-free-generate-btn",
};

export const MY_CREATIONS = {
  container: "my-creations-container",
  empty: "my-creations-empty",
  item: (id) => `my-creations-item-${id}`,
  player: (id) => `my-creations-player-${id}`,
  unlockCta: (id) => `my-creations-unlock-cta-${id}`,
  claimingBanner: "my-creations-claiming-banner",
};

export const GENERATOR = {
  hero: (slug) => `generator-hero-${slug}`,
  cta: (slug) => `generator-cta-${slug}`,
  faqItem: (id) => `generator-faq-item-${id}`,
  relatedLink: (slug) => `generator-related-link-${slug}`,
  breadcrumb: "generator-breadcrumb",
};

export const BLOG = {
  listItem: (slug) => `blog-list-item-${slug}`,
  articleCta: "blog-article-cta",
  relatedLink: (slug) => `blog-related-link-${slug}`,
  categoryFilter: (cat) => `blog-category-filter-${cat}`,
};


export const WIZARD = {
  container: "wizard-container",
  stepIndicator: (n) => `wizard-step-${n}`,
  nextBtn: "wizard-next-btn",
  prevBtn: "wizard-prev-btn",
  submitBtn: "wizard-submit-btn",
  guestGateModal: "wizard-guest-gate-modal",
  guestGateLoginBtn: "wizard-guest-gate-login-btn",
  guestGateEmailInput: "wizard-guest-gate-email-input",
  guestGateContinueBtn: "wizard-guest-gate-continue-btn",
  styleCard: (id) => `wizard-style-card-${id}`,
  moodCard: (id) => `wizard-mood-card-${id}`,
  songLanguageSelect: "wizard-song-language-select",
  subjectInput: "wizard-subject-input",
  personFirstName: "wizard-person-firstname",
  personLastName: "wizard-person-lastname",
  personDate: "wizard-person-date",
  eventSelect: "wizard-event-select",
  durationOption: (n) => `wizard-duration-${n}`,
  versionsOption: (n) => `wizard-versions-${n}`,
  lyricsModeAuto: "wizard-lyrics-mode-auto",
  lyricsModeCustom: "wizard-lyrics-mode-custom",
  customLyricsInput: "wizard-custom-lyrics-input",
  voiceEnabledSwitch: "wizard-voice-enabled-switch",
  voiceGenderHomme: "wizard-voice-gender-homme",
  voiceGenderFemme: "wizard-voice-gender-femme",
  vocalStyleOption: (id) => `wizard-vocal-style-${id}`,
  thumbnailSwitch: "wizard-thumbnail-switch",
  thumbnailSourceAi: "wizard-thumbnail-source-ai",
  thumbnailSourceUpload: "wizard-thumbnail-source-upload",
  uploadPhotoInput: "wizard-upload-photo-input",
  rushSwitch: "wizard-rush-switch",
  bonusInstrumentalSwitch: "wizard-bonus-instrumental-switch",
  titleModeAuto: "wizard-title-mode-auto",
  titleModeCustom: "wizard-title-mode-custom",
  customTitleInput: "wizard-custom-title-input",
  messagePosition: (id) => `wizard-message-position-${id}`,
  messageTextInput: "wizard-message-text-input",
  giftSwitch: "wizard-gift-switch",
  giftName: "wizard-gift-name",
  giftEmail: "wizard-gift-email",
  giftMessage: "wizard-gift-message",
  giftDate: "wizard-gift-date",
  youtubeSwitch: "wizard-youtube-switch",
  downloadSwitch: "wizard-download-switch",
  socialShortSwitch: "wizard-social-short-switch",
  translateSwitch: "wizard-translate-switch",
  translateLanguageSelect: "wizard-translate-language-select",
  certificateSwitch: "wizard-certificate-switch",
  galleryOptInSwitch: "wizard-gallery-opt-in-switch",
  voiceMessageSwitch: "wizard-voice-message-switch",
  voiceMessageTextInput: "wizard-voice-message-text-input",
  voiceMessagePosition: (id) => `wizard-voice-message-position-${id}`,
  priceCalculator: "wizard-price-calculator",
  priceTotal: "wizard-price-total",
};

export const CHECKOUT = {
  payBtn: "checkout-pay-btn",
  summary: "checkout-summary",
  walletBalance: "checkout-wallet-balance",
  buyPackBtn: (n) => `checkout-buy-pack-btn-${n}`,
  promoInput: "checkout-promo-input",
  promoApplyBtn: "checkout-promo-apply-btn",
  promoApplied: "checkout-promo-applied",
  trustBadges: "checkout-trust-badges",
};

export const ORDER = {
  statusBadge: "order-status-badge",
  player: "order-audio-player",
  playBtn: (v) => `order-play-btn-v${v}`,
  selectVersionBtn: (v) => `order-select-version-btn-v${v}`,
  downloadBtn: "order-download-btn",
  unlockDownloadBtn: "order-unlock-download-btn",
  shareBtn: "order-share-btn",
  deleteBtn: "order-delete-btn",
  invoiceBtn: "order-invoice-btn",
  shortClipPlayer: "order-short-clip-player",
  shortClipDownloadBtn: "order-short-clip-download-btn",
  certificateDownloadBtn: "order-certificate-download-btn",
  translatedLyricsToggle: "order-translated-lyrics-toggle",
  retryBtn: "order-retry-btn",
};

export const PUBLIC_SONG = {
  player: "public-song-player",
  createYoursCta: "public-song-create-cta",
};

export const DASHBOARD = {
  tabOrders: "dashboard-tab-orders",
  tabSongs: "dashboard-tab-songs",
  tabPayments: "dashboard-tab-payments",
  tabWallet: "dashboard-tab-wallet",
  tabSubscription: "dashboard-tab-subscription",
  tabProfile: "dashboard-tab-profile",
  tabReferral: "dashboard-tab-referral",
  orderRow: (id) => `dashboard-order-row-${id}`,
  buyTokenPack: (n) => `dashboard-buy-token-pack-${n}`,
  profileNameInput: "dashboard-profile-name-input",
  profileSaveBtn: "dashboard-profile-save-btn",
  profileCountrySelect: "dashboard-profile-country-select",
  profileCurrentPasswordInput: "dashboard-profile-current-password-input",
  profileNewPasswordInput: "dashboard-profile-new-password-input",
  profileChangePasswordBtn: "dashboard-profile-change-password-btn",
  profileDeleteAccountBtn: "dashboard-profile-delete-account-btn",
  profileDeleteConfirmPasswordInput: "dashboard-profile-delete-confirm-password-input",
  profileDeleteConfirmBtn: "dashboard-profile-delete-confirm-btn",
  profileHelpLink: (to) => `dashboard-profile-help-link-${to.replace(/\//g, "")}`,
  referralCopyBtn: "dashboard-referral-copy-btn",
};

export const PUSH = {
  prompt: "push-prompt-banner",
  enableBtn: "push-prompt-enable-btn",
  laterBtn: "push-prompt-later-btn",
};

export const SUBSCRIPTION = {
  plansContainer: "subscription-plans",
  planCard: (id) => `subscription-plan-card-${id}`,
  subscribeBtn: (id) => `subscription-subscribe-btn-${id}`,
  statusCard: "subscription-status-card",
  remaining: "subscription-remaining-count",
  usedBar: "subscription-usage-bar",
  renewInfo: "subscription-renew-info",
  cancelBtn: "subscription-cancel-btn",
  cancelConfirmBtn: "subscription-cancel-confirm-btn",
  manageOnPlayLink: "subscription-manage-play-link",
};

export const VOICE_RECORDER = {
  container: "voice-recorder",
  recordBtn: "voice-record-btn",
  stopBtn: "voice-stop-btn",
  uploadInput: "voice-upload-input",
  deleteBtn: "voice-delete-btn",
  confirmSaveBtn: "voice-confirm-save-btn",
  discardBtn: "voice-discard-btn",
  player: "voice-sample-player",
  pendingPlayer: "voice-pending-player",
  status: "voice-sample-status",
};

export const ADMIN = {
  tabOverview: "admin-tab-overview",
  tabUsers: "admin-tab-users",
  tabOrders: "admin-tab-orders",
  tabFunnel: "admin-tab-funnel",
  tabPayments: "admin-tab-payments",
  tabYoutube: "admin-tab-youtube",
  tabGifts: "admin-tab-gifts",
  tabEmails: "admin-tab-emails",
  searchInput: "admin-search-input",
  statusFilter: "admin-status-filter",
  exportCsvBtn: (type) => `admin-export-csv-${type}`,
  paymentsAnalytics: "admin-payments-analytics",
  userRow: (id) => `admin-user-row-${id}`,
  blockUserBtn: (id) => `admin-block-user-btn-${id}`,
  orderRow: (id) => `admin-order-row-${id}`,
  retryOrderBtn: (id) => `admin-retry-order-btn-${id}`,
  refundBtn: (id) => `admin-refund-btn-${id}`,
  markPublishedBtn: (id) => `admin-mark-published-btn-${id}`,
  markGiftSentBtn: (id) => `admin-mark-gift-sent-btn-${id}`,
  viewOrderDetailsBtn: (id) => `admin-view-order-details-btn-${id}`,
  orderDetailsDialog: "admin-order-details-dialog",
  downloadThumbnailBtn: (id) => `admin-download-thumbnail-btn-${id}`,
  resendEmailBtn: (id) => `admin-resend-email-btn-${id}`,
  creditTokensBtn: (id) => `admin-credit-tokens-btn-${id}`,
  creditTokensDialog: "admin-credit-tokens-dialog",
  creditAmountBtn: (n) => `admin-credit-amount-btn-${n}`,
  creditCustomAmountInput: "admin-credit-custom-amount-input",
  creditReasonInput: "admin-credit-reason-input",
  creditSubmitBtn: "admin-credit-submit-btn",
  viewHistoryBtn: (id) => `admin-view-history-btn-${id}`,
  historyDialog: "admin-history-dialog",
};
